<template>
    <div>
        <h5 :class="marginClass" class="title-2">{{ $t("surgery.presurgery") }}</h5>
        <h2 :class="marginClass" class="title">{{ $tc('surgery.adjuvantTreatment.title') }}</h2>
        <hr class="divider">

        <radio-checkbox-field
            :class="marginClass"
            :field="{label: $t('surgery.adjuvantTreatment.hasTreatmentLabel')}"
            v-model="hasTreatments"
            field-name="has-treatments"
        />

        <div class="ml-5" v-if="hasTreatments">
            <div class="mb-2" v-for="(choice, index) in $v.adjuvantTreatmentArray.$each.$iter" :key="index">
                <div>
                    <b-form-checkbox
                        class="align-baseline w-100"
                        :id="'adjuvant-treatment-' + index"
                        v-model="choice.selected.$model"
                    >
                        {{ adjuvantTreatmentFields.treatment_type.choices[index].display_name }}
                    </b-form-checkbox>
                </div>

                <div v-if="choice.selected.$model" class="nested-block">
                    <div >
                        <date-field
                            v-model="choice.date.$model"
                            :field="adjuvantTreatmentFields.date"
                            :field-name="'adjuvant-treatment-date-' + index"
                            :errors="choice.date.$error ? {['adjuvant-treatment-date-' + index]: [$t('error.required')] } : {}"
                            class="mb-3"
                            datetime
                        />
                    </div>

                    <div>
                        <input-field
                            v-model="choice.dose.$model"
                            :field="adjuvantTreatmentFields.dose"
                            :field-name="'adjuvant-treatment-amount-' + index"
                            :errors="choice.dose.$error ? {['adjuvant-treatment-amount-' + index]: [$t('error.required')] } : {}"
                            :form-width="10"
                            class="w-auto d-inline-block mb-3"
                        />
                    </div>

                    <div>
                        <input-field
                            v-model="choice.medication_schedule.$model"
                            :field="adjuvantTreatmentFields.medication_schedule"
                            :field-name="'adjuvant-treatment-schedule-' + index"
                            :errors="choice.medication_schedule.$error ? {['adjuvant-treatment-schedule-' + index]: [$t('error.required')] } : {}"
                            :form-width="20"
                            class="w-auto d-inline-block mb-3"
                        />
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import {mapStateProperty} from "@/utils/VuexHelpers";
    import {mapState} from "vuex";
    import RadioCheckboxField from "@/components/fields/RadioCheckboxField";
    import InputField from "@/components/fields/InputField";
    import SurgeryAddElementMixin from "@/components/mixins/NavigableComponentMixin";
    import {required, requiredIf} from "vuelidate/lib/validators";
    import {isArray} from "lodash";
    import DateField from "@/components/fields/DateField";

    export default {
        name: "AdjuvantTreatment",
        components: {DateField, InputField, RadioCheckboxField},
        mixins: [SurgeryAddElementMixin],
        data() {
            return {
                hasTreatments: false,
                adjuvantTreatmentArray: [],
            };
        },
        computed: {
            ...mapState(['adjuvantTreatmentFields']),
            ...mapStateProperty([
                'surgery.adjuvant_treatments',
            ]),
            marginClass() {
                return 'mx-4';
            },
        },
        created() {
            this.adjuvantTreatmentArray = this.adjuvantTreatmentFields.treatment_type.choices.map(element => {
                return {
                    selected: false,
                    treatment_type: element.value,
                    dose: null,
                    medication_schedule: null,
                    date: null,
                };
            });
            if (isArray(this.adjuvant_treatments) && this.adjuvant_treatments.length > 0) {
                this.hasTreatments = true;
                this.adjuvant_treatments.forEach(adjuvantSurgery => {
                    this.adjuvantTreatmentArray.forEach(adjuvant => {
                        if (adjuvantSurgery.treatment_type === adjuvant.treatment_type) {
                            adjuvant.selected = true;
                            adjuvant.dose = adjuvantSurgery.dose;
                            adjuvant.medication_schedule = adjuvantSurgery.medication_schedule;
                            adjuvant.date = adjuvantSurgery.date;
                        }
                    });
                });
            }
        },
        methods: {
            back() {
                this.storeAdjuvantTreatments();
            },
            validate() {
                this.$v.$touch();
                const isValid = !this.$v.$invalid;
                if (isValid) {
                    this.storeAdjuvantTreatments();
                }
                return isValid;
            },
            storeAdjuvantTreatments() {
                if (this.hasTreatments) {
                    let finalAdjuvantTreatments = [];
                    this.adjuvantTreatmentArray.forEach(adjuvantTreatment => {
                        if (adjuvantTreatment.selected) {
                            finalAdjuvantTreatments.push({
                                treatment_type: adjuvantTreatment.treatment_type,
                                dose: adjuvantTreatment.dose,
                                medication_schedule: adjuvantTreatment.medication_schedule,
                                date: adjuvantTreatment.date,
                            });
                        }
                    });
                    this.adjuvant_treatments = finalAdjuvantTreatments;
                } else {
                    this.adjuvant_treatments = [];
                }
            },
        },
        validations: {
            adjuvantTreatmentArray: {
                required,
                $each: {
                    selected: {},
                    date: {
                        required: requiredIf(function (adjuvantTreatment) {
                            return this.hasTreatments && adjuvantTreatment.selected;
                        })
                    },
                    dose: {
                        required: requiredIf(function (adjuvantTreatment) {
                            return this.hasTreatments && adjuvantTreatment.selected;
                        })
                    },
                    medication_schedule: {
                        required: requiredIf(function (adjuvantTreatment) {
                            return this.hasTreatments && adjuvantTreatment.selected;
                        })
                    },
                }
            }
        }
    };
</script>

<style scoped lang="scss">
    @import "src/custom.scss";

    .nested-block {
        @extend .ml-4;
    }
</style>